
export class LanguageUtils {
    public static deleteCookieForSubdomain(subDomain){
        var subdomains = ['an.opsnow.com', 'opsnow.com', subDomain];
        for (var i = 0; i < subdomains.length; i++) {
            $.cookie('BSP_LangCode', null, { expires: new Date(0), path: '/', domain: subdomains[i] });
        }
    }
    public static setLanguage() {
        const subDomain = LanguageUtils.getSubDomain();
        const userLang = LanguageUtils.getLangCode();
        let lang;
        if ($('#language > .btn-custom-select')[0].innerText) {
            lang = LanguageUtils.choiceLanguage($('#language > .btn-custom-select')[0].innerText);
        } else {
            lang = userLang; // 탭 복사 시 존재하지 않을 경우, 쿠키값을 그대로 설정함
        }

        if (userLang !== lang) {
            LanguageUtils.deleteCookieForSubdomain(subDomain);
            $.cookie('BSP_LangCode', lang, {domain: subDomain, expires: 365, path: '/'});
        }
    }

    public static getLangCode(): string {
        let userLang = 'en';
        const subDomain = LanguageUtils.getSubDomain();
        if ($.cookie('BSP_LangCode')) {
            userLang = $.cookie('BSP_LangCode');
        } else {
            if (location.host.indexOf('opsnow.cn') > -1) {
                userLang = 'zh';
            } else if (navigator.appVersion.indexOf('MSIE') > -1) { // Explorer
                userLang = navigator['userLanguage'].split('-')[0];
            } else {
                userLang = navigator.language.split('-')[0];
            }
            LanguageUtils.deleteCookieForSubdomain(subDomain);
            $.cookie('BSP_LangCode', userLang, {domain: subDomain, expires: 365, path: '/'});
        }
        return userLang;
    }

    public static choiceLanguage(lang): string {
        switch (lang) {
            case 'ko':
            case 'Korean':
            case '韓國語':
            case '한국어':
                return 'ko';
            case 'zh':
            case 'Chinese':
            case '简体中文':
            case '중국어':
                return 'zh';
            case '일본어':
            case '日本語':
            case 'ja':
                return 'ja';
            case 'en':
            case 'English':
            case '英語':
                return 'en';
            default:
                return 'en';
        }
    }

    public static getSubDomain(): string {
        const subDomain: string[] =  window.location.href.replace('http://', '').replace('https://', '').split('/')[0].split(':')[0].split('.');
        subDomain[0] = '';

        return subDomain.join('.');
    }

    public static getLangName(langCd): string {
        switch (langCd) {
            case 'en':
                return 'English';
            case 'ko':
                return '한국어';
            case 'zh':
                return '简体中文';
            case 'ja':
                return '日本語';
            default:
                return 'English';
        }

    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/language.utils.ts